import { createGlobalStyle } from "styled-components";
import { gb } from "./theme";

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body, #root {
    min-height: 100%;
  }

  body {
    font-family: "Press Start 2P", monospace;
    color: ${gb.dark};
    line-height: 1.5;
    background:
      radial-gradient(ellipse at 50% 30%, #243044 0%, #12161c 62%, #0a0c10 100%);
    overflow-x: hidden;
  }

  body::before {
    content: "";
    position: fixed;
    inset: 0;
    pointer-events: none;
    background-image:
      linear-gradient(rgba(155, 188, 15, 0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(155, 188, 15, 0.04) 1px, transparent 1px);
    background-size: 12px 12px;
    z-index: 0;
  }

  button, input {
    font-family: inherit;
  }

  button {
    cursor: pointer;
  }

  input {
    background: ${gb.light};
    color: ${gb.dark};
    border: 2px solid ${gb.dark};
    padding: 8px;
    font-size: 8px;
    width: 100%;
    border-radius: 0;

    &::placeholder {
      color: ${gb.mid};
    }

    &:focus {
      outline: none;
      background: ${gb.lightest};
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${gb.mid};
  }

  ::-webkit-scrollbar-thumb {
    background: ${gb.dark};
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;
